import { apiClient } from './apiClient';

export const serviceReportService = {
  // Get all reports
  async getReports() {
    return apiClient.get(`/api/cmms/reports`);
  },

  // Get reports by visit
  async getReportsByVisit(visitId) {
    return apiClient.get(`/api/cmms/reports/visit/${visitId}`);
  },

  // Get reports by contract
  async getReportsByContract(contractId) {
    return apiClient.get(`/api/cmms/reports/contract/${contractId}`);
  },

  // Get reports by supplier
  async getReportsBySupplier(supplierId) {
    return apiClient.get(`/api/cmms/reports/supplier/${supplierId}`);
  },

  // Get reports between dates
  async getReportsBetweenDates(startDate, endDate) {
    return apiClient.get(`/api/cmms/reports/between?startDate=${startDate}&endDate=${endDate}`);
  },

  // Get single report by ID
  async getReportById(id) {
    return apiClient.get(`/api/cmms/reports/${id}`);
  },

  // Create new report
  async createReport(data) {
    return apiClient.post(`/api/cmms/reports`, data);
  },

  // Update report
  async updateReport(id, data) {
    return apiClient.put(`/api/cmms/reports/${id}`, data);
  },

  // Delete report
  async deleteReport(id) {
    return apiClient.delete(`/api/cmms/reports/${id}`);
  },

  // Upload file to report
  async uploadFile(reportId, file, description = null, uploadedBy = null) {
    const formData = new FormData();
    formData.append('file', file);
    if (description) formData.append('description', description);
    if (uploadedBy) formData.append('uploadedBy', uploadedBy);

    return apiClient.upload(`/api/cmms/reports/${reportId}/files`, formData);
  },

  // Delete file from report
  async deleteFile(reportId, fileId) {
    return apiClient.delete(`/api/cmms/reports/${reportId}/files/${fileId}`);
  },
};
